import script from "./appcharts.vue?vue&type=script&setup=true&lang=ts"
export * from "./appcharts.vue?vue&type=script&setup=true&lang=ts"

import "./appcharts.vue?vue&type=style&index=0&id=05d2ddf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d2ddf0"]])

export default __exports__